export default "__VITE_ASSET__WykM_8d8__"